module.exports = "/_next/static/images/banner-uscis-status-explorer-community-small-e45543127e2c12b1af5144cd9d0e164d.png";